<template>
	<header class="gc-header">
		<div class="gc-header-inner">
			<a class="gc-brand" href="https://gixcore.com" aria-label="GixCore home">
				<span>Gix</span><span class="gc-brand-accent">Core</span>
			</a>

			<nav class="gc-nav" aria-label="Primary navigation">
				<router-link
					class="gc-nav-link gc-nav-link-signup"
					:class="{ 'is-active': $route.fullPath.includes('builder') }"
					to="/builder/home"
				>
					Builder
				</router-link>

				<span v-if="loggedIn == 'false'" class="gc-auth-links">
					<router-link
						class="gc-nav-link gc-nav-link-signup"
						:class="{ 'is-active': $route.name == 'Register' }"
						to="/users/register"
					>
						Sign Up
					</router-link>
					<router-link
						class="gc-nav-link gc-nav-link-signup"
						:class="{ 'is-active': $route.name == 'Login' }"
						to="/users/login"
					>
						Log In
					</router-link>
				</span>

				<span v-if="loggedIn == 'true'" class="gc-auth-links">
					<router-link
						class="gc-account-chip"
						:class="{ 'is-active': $route.path.indexOf('/users/') === 0 }"
						to="/users/dashboard"
						:title="'Open account: ' + accountIdentity"
						:aria-label="'Open account for ' + accountIdentity"
					>
						<span class="gc-account-copy">
							<span class="gc-account-status">Signed in as</span>
							<strong>{{ accountIdentity }}</strong>
						</span>
						<span class="gc-account-chevron" aria-hidden="true">›</span>
					</router-link>
				</span>
			</nav>
		</div>
	</header>
</template>

<script>
import { mapActions, mapGetters } 	from 'vuex'

export default {
	name: 'navbar',
	computed: {
		...mapGetters([
			'getToken',
			'getUser',
			'lastRoute',
			'loggedIn'
		]),
		user () {
			if (this.getUser && typeof this.getUser === 'object') return this.getUser
			if (typeof this.getUser === 'string') {
				try {
					return JSON.parse(this.getUser) || {}
				} catch (e) {
					return {}
				}
			}
			return {}
		},
		accountName () {
			const fullName = [this.user.first_name, this.user.last_name].filter(Boolean).join(' ')
			return fullName || this.user.username || ''
		},
		accountIdentity () {
			return this.user.email || this.accountName || 'Your account'
		}
	},
	methods: {
		...mapActions([
			'retrieveToken',
			'logout',
			'setLoggedIn',
			'setLoggedOut'
		]),
		handleLoginFormSubmit() {
			this.$store.dispatch('login', {
				email: this.email,
				password: this.password
			})
		},
		logoutLocal(){
			this.setLoggedOut()
			this.logout()
		},
	},
	created () {
		if (this.$route.path.includes('register')) {
			this.mode = 'register'
		}
		if (this.$route.path.includes('login')) {
			this.mode = 'login'
		}
		localStorage.removeItem('new-field')	
    },
	mounted() {
	}
}
</script>

<style scoped>
.gc-header {
	position: relative;
	z-index: 20;
	width: 100%;
	background: linear-gradient(180deg, rgba(8, 10, 15, 0.88), rgba(8, 10, 15, 0.36) 72%, rgba(8, 10, 15, 0));
}

.gc-header-inner {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	max-width: 1840px;
	min-height: 68px;
	margin: 0 auto;
	padding: 0.85rem 1.55rem;
}

.gc-brand {
	display: inline-flex;
	align-items: baseline;
	font-family: 'Audiowide', 'Aldrich', sans-serif;
	font-size: 29px;
	line-height: 1;
	color: #cfd2da;
	letter-spacing: 0;
	text-decoration: none;
	text-shadow: 0 0 18px rgba(25, 151, 198, 0.14);
}

.gc-brand:hover,
.gc-brand:focus {
	color: #ffffff;
	text-decoration: none;
}

.gc-brand-accent {
	color: #1997c6;
}

.gc-nav {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 1.05rem;
	white-space: nowrap;
}

.gc-auth-links {
	display: inline-flex;
	align-items: center;
	gap: 1.05rem;
}

.gc-nav-link {
	position: relative;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-height: 34px;
	padding: 0.3rem 0.12rem;
	color: #cfd2da;
	font-size: 14px;
	font-weight: 600;
	line-height: 1;
	letter-spacing: 0;
	text-transform: uppercase;
	text-decoration: none;
	transition: color 160ms ease, border-color 160ms ease, background 160ms ease;
}

.gc-nav-link::after {
	position: absolute;
	right: 0;
	bottom: 0;
	left: 0;
	height: 1px;
	background: #1997c6;
	box-shadow: 0 0 12px rgba(25, 151, 198, 0.7);
	content: "";
	opacity: 0;
	transform: scaleX(0.35);
	transition: opacity 160ms ease, transform 160ms ease;
}

.gc-nav-link:hover,
.gc-nav-link:focus,
.gc-nav-link.is-active {
	color: #1997c6;
	text-decoration: none;
}

.gc-nav-link:hover::after,
.gc-nav-link:focus::after,
.gc-nav-link.is-active::after {
	opacity: 1;
	transform: scaleX(1);
}

.gc-nav-link-signup {
	min-width: 92px;
	padding-right: 0.9rem;
	padding-left: 0.9rem;
	border: 1px solid rgba(25, 151, 198, 0.5);
	border-radius: 6px;
	background: rgba(25, 151, 198, 0.05);
}

.gc-nav-link-signup::after {
	display: none;
}

.gc-nav-link-signup:hover,
.gc-nav-link-signup:focus,
.gc-nav-link-signup.is-active {
	border-color: #1997c6;
	background: rgba(25, 151, 198, 0.14);
	box-shadow: inset 0 0 18px rgba(25, 151, 198, 0.06);
}

.gc-account-chip {
	display: inline-flex;
	align-items: center;
	gap: 0.65rem;
	max-width: 280px;
	min-height: 42px;
	padding: 0.45rem 0.55rem;
	border: 1px solid rgba(25, 151, 198, 0.5);
	border-radius: 8px;
	background:
		linear-gradient(135deg, rgba(25, 151, 198, 0.13), rgba(25, 151, 198, 0.035)),
		rgba(8, 13, 20, 0.74);
	color: #dce3eb;
	text-decoration: none;
	box-shadow: inset 0 0 18px rgba(25, 151, 198, 0.025);
	transition: border-color 160ms ease, background 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.gc-account-chip:hover,
.gc-account-chip:focus,
.gc-account-chip.is-active {
	border-color: #1997c6;
	background:
		linear-gradient(135deg, rgba(25, 151, 198, 0.2), rgba(25, 151, 198, 0.07)),
		rgba(8, 13, 20, 0.86);
	color: #ffffff;
	text-decoration: none;
	box-shadow: 0 0 20px rgba(25, 151, 198, 0.1), inset 0 0 18px rgba(25, 151, 198, 0.06);
	transform: translateY(-1px);
}

.gc-account-copy {
	display: flex;
	min-width: 0;
	flex-direction: column;
	gap: 0.14rem;
	text-align: left;
}

.gc-account-status {
	color: #7e8d9e;
	font-size: 9px;
	font-weight: 700;
	line-height: 1;
	letter-spacing: 0.08em;
	text-transform: uppercase;
}

.gc-account-copy strong {
	display: block;
	overflow: hidden;
	color: #e6edf4;
	font-size: 12px;
	font-weight: 700;
	line-height: 1.1;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.gc-account-chevron {
	flex: 0 0 auto;
	color: #1997c6;
	font-size: 20px;
	line-height: 1;
	transform: translateY(-1px);
}

@media screen and (max-width: 640px) {
	.gc-header-inner {
		min-height: 62px;
		padding: 0.8rem 1rem;
	}

	.gc-brand {
		font-size: 24px;
	}

	.gc-nav,
	.gc-auth-links {
		gap: 0.65rem;
	}

	.gc-nav-link {
		font-size: 12px;
	}

	.gc-nav-link-signup {
		min-width: 76px;
		padding-right: 0.65rem;
		padding-left: 0.65rem;
	}

	.gc-account-chip {
		max-width: 170px;
		gap: 0.5rem;
	}

	.gc-account-copy strong {
		max-width: 94px;
	}
}

@media screen and (max-width: 460px) {
	.gc-header-inner {
		padding-right: 0.75rem;
		padding-left: 0.75rem;
	}

	.gc-nav,
	.gc-auth-links {
		gap: 0.45rem;
	}

	.gc-account-chip {
		gap: 0.35rem;
		width: 124px;
		min-height: 38px;
		padding: 0.4rem 0.55rem;
	}

	.gc-account-status,
	.gc-account-chevron {
		display: none;
	}

	.gc-account-copy strong {
		max-width: 108px;
	}
}
</style>
